import { render, staticRenderFns } from "./FoodPrices.vue?vue&type=template&id=d80444d0&"
import script from "./FoodPrices.vue?vue&type=script&lang=js&"
export * from "./FoodPrices.vue?vue&type=script&lang=js&"
import style0 from "./FoodPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports